import { api } from '@/services/api/main/axios';
import { useWorkspace } from '@/composables/useWorkspace';

export const getOffersApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('offers', { params });
  return res.data.payload;
};

export type GetOffersListParams = {
  search?: string;
  status?: string;
  limit?: string | number;
  orderBy?: string;
  orderDirection?: string;
  columns?: string[];
  countryId?: number;
  workspaceId?: string;
};

export const getOffersListApiRequest = async (
  params: GetOffersListParams,
): Promise<unknown[]> => {
  const { workspaceId, ...rest } = params;
  const workspaceApi = useWorkspace();
  const requestParams: Record<string, unknown> = {
    ...rest,
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
  };
  return getOffersApiRequest(requestParams);
};

export const getOfferApiRequest = async (id: string): Promise<Record<string, unknown>> => {
  const res = await api.get<{ payload: Record<string, unknown> }>(`offers/${id}`);
  return res.data.payload;
};

export const postCreateOfferApiRequest = async (
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.post<{ payload: Record<string, unknown> }>('offers', payload);
  return res.data.payload;
};

export const putUpdateOfferApiRequest = async (
  id: string,
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.put<{ payload: Record<string, unknown> }>(`offers/${id}`, payload);
  return res.data.payload;
};

export const putOffersBulkUpdateApiRequest = async (
  workspaceId: string,
  payload: object,
): Promise<void> => {
  await api.put(`offers/workspace/${workspaceId}/bulk-update`, payload);
};

export const getOffersCountApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<{ count: number }> => {
  const res = await api.get<{ payload: { count: number } }>('offers/count', { params });
  return res.data.payload;
};

export const postOffersImportApiRequest = async (payload: object): Promise<void> => {
  await api.post('offers/import', payload);
};
